export default "https://cdn-static.gokick.com/assets/5330764b9b84e4374a94f4eff9433164072ac9e6/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";